import { IconSpeakerphone } from '@tabler/icons-react';
import classes from './news.module.css';

const News = () => (
  <ul className={classes.news}>
    <li className={classes.item}>
      <div className={classes.item}>
        <div className={classes.icon}><IconSpeakerphone stroke={1.5} /></div>
        <div className={classes.body}>
          <div className={classes.title}>כותרת הודעה</div>
          <div className={classes.content}>
            <p>
              לורם איפסום דולור אמט, קונסקטורר אדיפיסינג אלית
              לורם איפסום דולור אמט, קונסקטורר אדיפיסינג אלית.
              סת אלמנקום ניסי נון ניבאה.
            </p>
          </div>
        </div>
      </div>
    </li>
  </ul>
);

export default News;
